import PropTypes from 'prop-types';

const iniciales = (nombre) =>
  (nombre || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();

const Avatar = ({ nombre = '', size = 'md' }) => (
  <span
    className={`tickets-avatar tickets-avatar--${size}`}
    aria-hidden="true"
    title={nombre || undefined}
  >
    {iniciales(nombre) || '?'}
  </span>
);

Avatar.propTypes = {
  nombre: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default Avatar;
